'use client'
import {BookingRulesSection} from '../shared/BookingRulesSection'
import type {PublicScheduleEvent} from '../../../services/public-schedule.service'

export function PublicBookingRules({event, inline}: {event: Pick<PublicScheduleEvent, 'bookingClosesAt' | 'cancellationClosesAt' | 'timeZone' | 'eventRulesHtml'>; inline?: boolean}) {
    return <BookingRulesSection inline={inline} registrationClosesAt={event.bookingClosesAt} cancellationClosesAt={event.cancellationClosesAt}
        timeZone={event.timeZone} rules={{html: event.eventRulesHtml}}/>
}
